<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home text-center">
        <span class="failure">{{ failureMessage }}</span>
        <div v-if="user && user.id">
          <router-link :to="{ name: 'CreateClub' }">
            <c-button variant="primary" class="right-align margin-right">Create Club</c-button>
          </router-link>
          <br>
          <br>
          <div class="text-center"><h4 class="inline">My Clubs</h4>&nbsp;&nbsp;(Total clubs: {{ userClubsPagination.count }})</div>
          <b-table :fields="userClubsTable" :items="userClubs" responsive="sm">
            <template #cell(name)="data">
              <router-link class="text-black" :to="{ name: 'Club', params: { id: data.item.club.id }}">
                <b>{{ data.item.club.name }}</b>
              </router-link>
            </template>
            <template #cell(country)="data">
              {{ data.item.club.country }}
            </template>
            <template #cell(trophies)="data">
              {{ data.item.club.trophies }}
            </template>
            <template #cell(rank)="data">
              {{ data.item.rank }} / {{ data.item.club.riders }}
            </template>
            <template #cell(role)="data">
              {{ data.item.role | capitalize }}
            </template>
            <template #cell(visibility)="data">
              {{ data.item.isPrivate ? 'Private' : 'Public' }}
            </template>
          </b-table>
          <div class="center-align">
            <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listUserClubs', 'userClubsPagination')"/>
              Page: {{ userClubsPagination.page }} / {{ userClubsPagination.totalPages }}
            <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listUserClubs', 'userClubsPagination')"/>
          </div>
          <br>
          <br>
          <br>
        </div>
        <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3" cols-xl="3">
          <b-col>
          </b-col>
          <b-col>
            <div class="text-center"><h4 class="inline">All Clubs</h4>&nbsp;&nbsp;(Total clubs: {{ clubsPagination.count }})</div>
          </b-col>
          <b-col>
            <div class="inline2">
              <fa-icon v-if="country" class="margin-top-15 margin-right" icon="times" @click="resetCountry()"/>
              <multiselect
                v-model="country"
                :options="countries"
                placeholder="Search for a country"
                select-label=""
                :multiple="false"
                :searchable="true"
                :hide-selected="true"
                >
              </multiselect>
            </div>
          </b-col>
        </b-row>
        <b-table :fields="clubsTable" :items="clubs" responsive="sm">
          <template #cell(name)="data">
            <router-link class="text-black" :to="{ name: 'Club', params: { id: data.item.id }}">
              <b>{{ data.item.name }}</b>
            </router-link>
          </template>
          <template #cell(country)="data">
            {{ data.item.country }}
          </template>
          <template #cell(riders)="data">
            {{ data.item.riders }}
          </template>
          <template #cell(trophies)="data">
            {{ data.item.trophies }}
          </template>
          <template #cell(createdAt)="data">
            {{ data.item.createdAt | date }}
          </template>
          <template #cell(owner)="data">
            <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.owner.id }}">
              <img v-if="data.item.owner.stravaDetails.profile" :src="data.item.owner.stravaDetails.profile" width="25px">
              <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
              <b class="margin-left">{{ data.item.owner.stravaDetails.firstname }} {{ data.item.owner.stravaDetails.lastname }}</b>
            </router-link>
            &nbsp;<b-badge pill variant="primary">{{ data.item.owner.level }}</b-badge>
          </template>
        </b-table>
        <div class="center-align">
          <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listClubs', 'clubsPagination')"/>
            Page: {{ clubsPagination.page }} / {{ clubsPagination.totalPages }}
          <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listClubs', 'clubsPagination')"/>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import Multiselect from 'vue-multiselect';
  import countries from '@/countries.js';
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Clubs',
    components: { CButton, Multiselect },
    props: {

    },
    data() {
      return {
        failureMessage: '',
        country: null,
        countries,
        clubs: [],
        clubsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        clubsTable: [
          {
            key: 'name'
          },
          {
            key: 'country'
          },
          {
            key: 'riders',
            label: 'Members'
          },
          {
            key: 'trophies'
          },
          {
            key: 'createdAt',
            label: 'Created on'
          },
          {
            key: 'owner'
          },
        ],
        userClubs: [],
        userClubsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        userClubsTable: [
          {
            key: 'name'
          },
          {
            key: 'country'
          },
          {
            key: 'trophies'
          },
          {
            key: 'rank'
          },
          {
            key: 'role'
          },
          {
            key: 'visibility'
          },
        ],
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})

      await this.listClubs()
      if (this.user && this.user.id) await this.listUserClubs()
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    watch: {
      country(newCountry, oldCountry) {
        this.listClubs({ resetPage: true })
      }
    },
    methods: {
      async listClubs({ resetPage } = {}) {
        this.failureMessage = ''
        this.clubs = []

        if (resetPage) this.clubsPagination.page = 1

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listClubs.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            country: this.country,
            page: this.clubsPagination.page,
            itemsPerPage: this.clubsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listClubs) {
          this.clubs.push(...result.data.listClubs.clubs)
          this.clubsPagination.count = result.data.listClubs.pagination.count
          this.clubsPagination.totalPages = result.data.listClubs.pagination.totalPages
        }
      },
      async listUserClubs() {
        this.failureMessage = ''
        this.userClubs = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listUserClubs.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            userId: this.user.id,
            page: this.userClubsPagination.page,
            itemsPerPage: this.userClubsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listUserClubs) {
          this.userClubs.push(...result.data.listUserClubs.userClubs)
          this.userClubsPagination.count = result.data.listUserClubs.pagination.count
          this.userClubsPagination.totalPages = result.data.listUserClubs.pagination.totalPages
        }
      },
      resetCountry() {
        this.country = null
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
    }
  }
</script>

<style scoped>
  .inline2 {
    display: flex;
    justify-content: space-between;  
  }
</style>
